import React from "react";
import "./ChecklistTeacherVorbereitung.scss";
import TeacherChecklistForm from "../TeacherChecklistForm";
export default function ChecklistTeacherVorbereitung() { return <TeacherChecklistForm type="vorbereitung" />; }
